import { Button, Card, Col, Divider, Row } from 'antd';
import { useEffect, useState } from 'react';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import SettlementService from '@root/modules/Sellers/Settlement/services/settlement';
import { useLocation, useParams } from 'react-router-dom';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import metaApi from '@root/core/components/CountryPhoneInput/meta-service';


const SettlementDetail: React.FC = () => {
  const [infoDetail, setInfoDetail] = useState({} as any);
  const { id }: any = useParams();
  const { search } = useLocation();
  const [countryCode, setCountryCode] = useState<string>('');
  const [ callingcode, setCallingCode] = useState([] as any)
  const Breadcrumb = [
    {
      tittle: '정산 관리',
      url: ''
    },
    {
      tittle: '정산 조회',
      url: ''
    },
    {
      tittle: '정산 상세',
      url: ''
    }
  ];

  const getDetail = async () => {
    try {
      const detail = await SettlementService.getDetail(Number(id));
      let detailUse = detail.data;
      if (
        !!search &&
        detailUse.billingStatus !== 'Completed' &&
        search.includes('paymentStatus=Success')
      ) {
        let params = search.replace('?', '').split('&');
        let paramUse: any = [];
        params.forEach((x, n) => {
          let t = x.split('=');
          paramUse = [...paramUse, ...[t]];
        });
        let body = Object.fromEntries(paramUse);
        body.inquiryId = id;
        body.payerID = body.PayerID;
        delete body.PayerID;
        delete body.paymentStatus;
        const callCallbackOrder = await SettlementService.CaptureOrder(body);
        detailUse.billingStatus = 'Completed';
        setInfoDetail(detailUse);
      } else {
        setInfoDetail(detailUse);
      }
      setCountryCode(detailUse.seller.companyCountryCode ?? infoDetail.warehouse.countryCode)
    } catch (e) {
      setInfoDetail(null);
    }
  };

  const SaveFile = () => {
    saveAs(
      infoDetail?.billingInquiryFile?.url,
      infoDetail?.billingInquiryFile?.fileName
    );
  };

  // const newDetail = async () =>{
  //   try {
  //     const [responseData,detail] = await Promise.all([metaApi['getMetaData'](),SettlementService.getDetail(Number(id))]);
  //     let data = detail.data
  //     data.warehouse.countryCode = responseData?.data.country_code.find(
  //       (item:any) => item.lookupCodeId === data.warehouse.countryCode
  //     ).calling_code;
  //     data.seller.countryCode = responseData?.data.country_code.find(
  //       (item:any) => item.lookupCodeId === data.seller.countryCode
  //     ).calling_code;
  //     if (
  //       !!search &&
  //       data.billingStatus !== 'Completed' &&
  //       search.includes('paymentStatus=Success')
  //     ) {
  //       let params = search.replace('?', '').split('&');
  //       let paramUse: any = [];
  //       params.forEach((x, n) => {
  //         let t = x.split('=');
  //         paramUse = [...paramUse, ...[t]];
  //       });
  //       let body = Object.fromEntries(paramUse);
  //       body.inquiryId = id;
  //       body.payerID = body.PayerID;
  //       delete body.PayerID;
  //       delete body.paymentStatus;
  //       const callCallbackOrder = await SettlementService.CaptureOrder(body);
  //       data.billingStatus = 'Completed';
  //       setInfoDetail(data);
  //     } else {
  //       setInfoDetail(data);
  //     }
  //   } catch (e) {
  //     setInfoDetail(null);
  //   }
  // }

  const newData = (countryData :any) =>{
    if (countryData.length > 0 && (!!infoDetail?.seller?.companyCountryCode || !!infoDetail?.warehouse?.countryCode))
    {
      let data = infoDetail
      data.warehouse.countryCode = countryData.find(
        (item:any) => item.lookupCodeId === data.warehouse.countryCode
      ).calling_code ?? '';
      data.seller.countryCode = countryData.find(
        (item:any) => item.lookupCodeId === data.seller.countryCode
      ).calling_code ?? '';
      setCallingCode([data.warehouse.countryCode ?? '',data.seller.countryCode ?? ''])
    }
  }

  const getCallingCode = async () =>{
    try{
      if(!!countryCode){
        const responseData = await metaApi['getMetaData']();
        newData(responseData.data.country_code)
      }
    }catch(e){

    }
  }

  useEffect(() => {
    getCallingCode();
  }, [countryCode]);
  
  useEffect(() => {
    getDetail();
  }, []);

  // useEffect(() => {
  //   getDetail();
  // }, []);

  // useEffect(() => {
  //   newDetail();
  // }, []);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      {infoDetail.id && (
        <div className="admin-container">
          <Card
            bordered={false}
            className="admin-card"
            style={{
              minHeight: '80vh',
              background: 'none'
            }}
          >
            <div style={{ display: 'flex' }}>
              <Card
                style={{
                  width: '35%',
                  marginBottom: '1rem',
                  padding: '1rem 0 1rem 1rem',
                  marginRight: '1rem',
                  minHeight: '10rem'
                }}
              >
                <div style={{ display: 'flex', lineHeight: '2.5rem' }}>
                  <div style={{ width: '40%' }}>
                    <h3>셀러 ID</h3>
                    <h3>물류센터 ID</h3>
                    <h3>영수증 번호</h3>
                  </div>
                  <Divider type="vertical" />
                  <div style={{ width: '50%' }}>
                    <h3>
                      {infoDetail?.seller?.firstName}{' '}
                      {infoDetail?.seller?.lastName}
                    </h3>
                    <h3>{infoDetail?.warehouse.name}</h3>
                    <h3>{infoDetail?.receiptId}</h3>
                  </div>
                </div>
              </Card>
              <Card
                style={{
                  width: '60%',
                  marginBottom: '1rem',
                  padding: '0.5rem 1.5rem 0 1.5rem',
                  marginRight: '1rem'
                }}
              >
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <h2>From.</h2>
                    <span>{infoDetail.warehouse.name}&emsp;&emsp;</span>
                    <span>{infoDetail.warehouse.countryName}</span>
                    <div>
                      <span>Tel: &emsp;</span>
                      <span>
                        +{callingcode[0] ?? ''}{' '}
                        {infoDetail.warehouse.phoneNumber}
                      </span>
                    </div>
                    <div>
                      Email: &emsp; <span>{infoDetail.warehouse.email}</span>
                    </div>
                    <p className="address">
                      {infoDetail.warehouse.detailAddress}
                      <br />
                      {infoDetail.warehouse.state}
                      <br />
                      {infoDetail.warehouse.country}
                    </p>
                  </div>
                  <div>
                    <h2>To.</h2>
                    <span>
                      {infoDetail?.seller.firstName}{' '}
                      {infoDetail.seller.lastName} &emsp;&emsp;
                    </span>
                    <span>{infoDetail?.seller.country}</span>
                    <div>
                      Tel: &emsp;{' '}
                      <span>
                        +{callingcode[1] ?? ''}{' '}
                        {infoDetail.seller.phoneNumber}
                      </span>
                    </div>
                    <div>
                      Email: &emsp; <span>{infoDetail.seller.email}</span>
                    </div>
                    <p className="address">
                      {infoDetail?.seller?.detailAddress}
                      <br />
                      {infoDetail.seller.state}
                      <br />
                      {infoDetail.seller.country}
                    </p>
                  </div>
                </div>
              </Card>
            </div>
            <div>
              <Card style={{ marginRight: '1rem', padding: '1rem' }}>
                <div>
                  <Row style={{ marginBottom: '25px' }}>
                    <Col span={8}>
                      <h2 style={{ marginBottom: '20px' }}>견적 내역</h2>
                    </Col>
                    <Col span={16} align="right">
                      <div>
                        <span>{formatDateTime(infoDetail.created_at)}</span>{' '}
                        &emsp; - &emsp;{' '}
                        <span> {formatDateTime(infoDetail.updated_at)}</span>
                      </div>
                    </Col>
                    <Col span={6} style={{ alignSelf: 'center' }}>
                      <p style={{ margin: 0 }}>물류센터에 입고 상품 종류 </p>
                    </Col>
                    <Col span={16}>
                      <Divider dashed style={{ borderWidth: '2px 0 0' }} />
                    </Col>
                    <Col span={3} align="right" style={{ alignSelf: 'center' }}>
                      <p style={{ margin: 0 }}>
                        {infoDetail.numberProductTypes}
                      </p>
                    </Col>
                    <Col span={6} style={{ alignSelf: 'center' }}>
                      <p style={{ margin: 0 }}>총 주문 상품 개수 </p>
                    </Col>
                    <Col span={16}>
                      <Divider dashed style={{ borderWidth: '2px 0 0' }} />
                    </Col>
                    <Col span={3} align="right" style={{ alignSelf: 'center' }}>
                      <p style={{ margin: 0 }}>{infoDetail.orderCounts} </p>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: '25px' }}>
                    <Col span={24}>
                      <h2>입고 내역</h2>
                    </Col>
                    <Col span={6} style={{ alignSelf: 'center' }}>
                      <p style={{ margin: 0 }}>물류센터에 입고 상품 개수 </p>
                    </Col>
                    <Col span={16}>
                      <Divider dashed style={{ borderWidth: '2px 0 0' }} />
                    </Col>
                    <Col span={3} align="right" style={{ alignSelf: 'center' }}>
                      <p style={{ margin: 0 }}>{infoDetail.numberDelivered}</p>
                    </Col>
                    <Col span={6} style={{ alignSelf: 'center' }}>
                      <p style={{ margin: 0 }}>판매자에게 반송된 상품 개수</p>
                    </Col>
                    <Col span={16}>
                      <Divider dashed style={{ borderWidth: '2px 0 0' }} />
                    </Col>
                    <Col span={3} align="right" style={{ alignSelf: 'center' }}>
                      <p style={{ margin: 0 }}>{infoDetail.numberReturn}</p>
                    </Col>
                    <Col span={6} style={{ alignSelf: 'center' }}>
                      <p style={{ margin: 0 }}>폐기 상품 개수</p>
                    </Col>
                    <Col span={16}>
                      <Divider dashed style={{ borderWidth: '2px 0 0' }} />
                    </Col>
                    <Col span={3} align="right" style={{ alignSelf: 'center' }}>
                      <p style={{ margin: 0 }}>{infoDetail.numberDisposal} </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6} style={{ alignSelf: 'center' }}>
                      <h2 style={{ margin: 0 }}>총 결제 금액</h2>
                    </Col>
                    <Col span={16}>
                      <Divider dashed style={{ borderWidth: '2px 0 0' }} />
                    </Col>
                    <Col span={3} align="right" style={{ alignSelf: 'center' }}>
                      <h2 style={{ margin: 0 }}>
                        US$ &nbsp;
                        {Number(infoDetail.billingAmount).toLocaleString(
                          'en-US'
                        )}
                      </h2>
                    </Col>
                  </Row>
                </div>
              </Card>
            </div>
            <div className="container-tag-button button-page-shipping">
              <div className="tag-button">
                <div className="button-container">
                  <Button type="default" onClick={() => SaveFile()}>
                    거래 명세서 다운로드
                  </Button>
                </div>
                <div className="button-container">
                  <Button
                    className="renueProduct"
                    disabled={
                      infoDetail.billingStatus == 'Completed' ||
                      !infoDetail?.paypalApproveUrl
                    }
                    onClick={() => {
                      window.location.href = infoDetail?.paypalApproveUrl;
                    }}
                  >
                    페이팔로 결제
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
};

export default SettlementDetail;
